import { createContext, useContext } from "react";
import { TourDefinition } from "./tourTypes";

// Context for the guided-tour engine. Kept in its own file so TourProvider and
// TourOverlay can both import it without a circular dependency.
export interface TourContextValue {
  isActive: boolean;
  activeTour?: TourDefinition;
  stepIndex: number;
  startTour: (tourId: string) => void;
  next: () => void;
  prev: () => void;
  stop: (opts?: { completed?: boolean }) => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

export const useTour = (): TourContextValue => {
  const ctx = useContext(TourContext);
  if (!ctx) throw Error("useTour must be used within a TourProvider.");
  return ctx;
};
